export const familyMedicineConst = {
  path: "/single-programs/family-medicine",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – СЕМЕЙНАЯ МЕДИЦИНА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Семейная медицина — первый и главный контакт пациента с системой здравоохранения</h2>
      <p>
        Семейная медицина — это основа здравоохранения любой страны. Она готовит универсальных врачей, которые умеют диагностировать, лечить
        и сопровождать пациентов на всех этапах жизни — от рождения до старости. Это врачи, которым доверяют семьи, которые знают всю
        историю здоровья своих пациентов, и могут оказывать комплексную помощь.
      </p>
      <p>
        Семейный врач — это не просто медицинский специалист, это ключевая фигура в системе первичной медико-санитарной помощи, способный
        решать до 80% всех обращений без направления к узким специалистам.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Внутренние болезни и терапевтическую практику</li>
        <li>Педиатрию и ведение детей с рождения</li>
        <li>Гериатрию — медицину пожилого возраста</li>
        <li>Гинекологию и репродуктивное здоровье</li>
        <li>Профилактику заболеваний и вакцинацию</li>
        <li>Медицину неотложных состояний</li>
        <li>Организацию первичной медико-санитарной помощи</li>
        <li>Коммуникацию с пациентом, психологию доверия</li>
      </ul>
      <p>
        Программа сочетает теорию, амбулаторную практику и клинические стажировки в учреждениях ЕС. Особое внимание уделяется долгосрочному
        ведению пациентов и взаимодействию с их семьями.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Семейный врач в государственной или частной поликлинике</li>
        <li>Врач общей практики в клиниках Европы</li>
        <li>Участковый терапевт или врач выездной помощи</li>
        <li>Руководитель семейной амбулатории</li>
        <li>Консультант в проектах общественного здравоохранения и профилактики заболеваний</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €100,000 в год,</strong> в зависимости от страны, опыта и уровня учреждения.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Гибкие формы обучения — очно или дистанционно</li>
        <li>Обучение ведут практикующие семейные врачи с международным опытом</li>
        <li>Клинические стажировки в европейских поликлиниках</li>
        <li>Модульная система и удобный график обучения</li>
        <li>Поддержка при трудоустройстве и адаптации за рубежом</li>
        <li>Возможность учиться на русском или английском языке</li>
      </ul>
      <p>
        <strong>
          Семейная медицина — это не просто профессия. Это миссия помогать людям каждый день, знать их историю, быть рядом в самые важные
          моменты жизни.
        </strong>
      </p>
      <h2>Как поступить?</h2>
      <p>
        Мы позаботились, чтобы путь в профессию был простым. Оставьте заявку, и приёмная комиссия свяжется с вами, поможет выбрать формат
        обучения, подготовить документы и начать обучение в удобное для вас время.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Семейная медицина — первый и главный контакт пациента с системой здравоохранения
    Семейная медицина — это основа здравоохранения любой страны. Она готовит универсальных врачей, которые умеют диагностировать, лечить и сопровождать пациентов на всех этапах жизни — от рождения до старости. Это врачи, которым доверяют семьи, которые знают всю историю здоровья своих пациентов, и могут оказывать комплексную помощь.
    Семейный врач — это не просто медицинский специалист, это ключевая фигура в системе первичной медико-санитарной помощи, способный решать до 80% всех обращений без направления к узким специалистам.

    Что вы будете изучать?
    • Внутренние болезни и терапевтическую практику
    • Педиатрию и ведение детей с рождения
    • Гериатрию — медицину пожилого возраста
    • Гинекологию и репродуктивное здоровье
    • Профилактику заболеваний и вакцинацию
    • Медицину неотложных состояний
    • Организацию первичной медико-санитарной помощи
    • Коммуникацию с пациентом, психологию доверия
    Программа сочетает теорию, амбулаторную практику и клинические стажировки в учреждениях ЕС. Особое внимание уделяется долгосрочному ведению пациентов и взаимодействию с их семьями.

    Кем можно работать после окончания?
    • Семейный врач в государственной или частной поликлинике
    • Врач общей практики в клиниках Европы
    • Участковый терапевт или врач выездной помощи
    • Руководитель семейной амбулатории
    • Консультант в проектах общественного здравоохранения и профилактики заболеваний

    Средний доход в Европе:
    от €60,000 до €100,000 в год, в зависимости от страны, опыта и уровня учреждения.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Гибкие формы обучения — очно или дистанционно
    • Обучение ведут практикующие семейные врачи с международным опытом
    • Клинические стажировки в европейских поликлиниках
    • Модульная система и удобный график обучения
    • Поддержка при трудоустройстве и адаптации за рубежом
    • Возможность учиться на русском или английском языке

    Семейная медицина — это не просто профессия. Это миссия помогать людям каждый день, знать их историю, быть рядом в самые важные моменты жизни.
    Как поступить?
    Мы позаботились, чтобы путь в профессию был простым. Оставьте заявку, и приёмная комиссия свяжется с вами, поможет выбрать формат обучения, подготовить документы и начать обучение в удобное для вас время. 
  `,
};
